const $$splitComponentImporter = () => import('/src/src/routes/_authenticated/_feature_announcement/admin/system/branding/colors.tsx?tsr-split=component');
import { lazyRouteComponent } from '@tanstack/react-router';
import { createFileRoute } from "@tanstack/react-router";
import { defineMessage } from "react-intl";
export const Route = createFileRoute("/_authenticated/_feature_announcement/admin/system/branding/colors")({
  component: lazyRouteComponent($$splitComponentImporter, 'component'),
  staticData: {
    pageTitle: defineMessage({
      defaultMessage: "Branding colors",
      description: "Page title for the branding colors path"
    })
  }
});